<template>
  <div class="vue-container container" :class="[$common.lang]">
    <section class="top">
      <div class="user">
        <div class="info">
          <div class="avatar">
            <img :src="info.avatar" />
          </div>
          <div class="nickname">{{ info.nickname }}</div>
        </div>
        <div class="date">
          <div class="year-month-week">
            <div class="year-month">{{ info.year }}.{{ info.month }}</div>
            <div class="week">{{ info.week }}</div>
          </div>
          <div class="day">{{ info.day }}</div>
        </div>
      </div>
      <div class="invite-code" v-if="info.invite_code">
        <div class="label">
          {{ $t("邀请码") }}: <span class="code">{{ info.invite_code }}</span>
        </div>
        <div class="desc">{{ $t("用邀请码注册，参与抽大奖") }}</div>
      </div>
      <div class="slogan" v-html="$t('快跟我一起来<br />SuperChinese学中文吧!')"></div>
    </section>
    <section
      class="content"
      ref="content"
      :style="{
        minHeight: contentMinHeight + 'px',
        paddingBottom: contentPaddingBottom + 'px',
      }"
    >
      <div class="description">
        <div class="row">
          <div class="ico ico-a"></div>
          <div class="text">
            <div class="title title-a">{{ $t("零基础任性学") }}</div>
            <div class="desc">{{ $t("听说读写全面提升") }}</div>
          </div>
        </div>
        <div class="row">
          <div class="ico ico-b"></div>
          <div class="text">
            <div class="title title-b">{{ $t("趣味对话") }}</div>
            <div class="desc">{{ $t("100+日常对话等你来") }}</div>
          </div>
        </div>
        <div class="row">
          <div class="ico ico-c"></div>
          <div class="text">
            <div class="title title-c">{{ $t("智能AI") }}</div>
            <div class="desc">{{ $t("个性化学习推荐，由浅入深系统学") }}</div>
          </div>
        </div>
      </div>
    </section>
    <section class="bottom" ref="bottom">
      <div class="action">
        <div class="logo-text">
          <div class="logo"></div>
          <div class="text">{{ $t("零基础任性学") }}<br />{{ $t("趣味对话等你来") }}</div>
        </div>
        <div class="button-open" id="openInstallButton">
          {{ $t("立即打开") }}
        </div>
      </div>
    </section>
    <!-- openOtherBroswer -->
    <div class="open-other-broswer" v-show="showOpenOtherBroswer">
      <div
        class="mask"
        @click="showOpenOtherBroswer = !showOpenOtherBroswer"
        :style="{ minHeight: maskMinHeight + 'px' }"
      ></div>
      <div class="arrow"></div>
      <div class="contents">
        <div class="text" v-html="$t('点击右上角的按钮,选择在浏览器中打开')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import globalMixin from "@/mixins/global";
export default {
  name: "invite",
  mixins: [globalMixin],
  data() {
    return {};
  },
  mounted() {
    this.loadInfo(this.afterLoadInfo);
    this.openinstall(this.beforeOpeninstall);
  },
  methods: {
    afterLoadInfo() {
      // firebase.logEvent('InvitationWithPrizeShareH5', {uid: this.info.uid})
    },
    beforeOpeninstall() {
      var userAgent = navigator.userAgent || window.opera;
      console.log(userAgent);
      if (
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPod/i)
      ) {
        window.open("https://www.superchinese.com/app");
      } else {
        window.open("ujjzkx://sc");
      }
    },
  },
};
</script>

<style lang="stylus" scoped="scoped">
.container{
	background-color #12284C
	.open-other-broswer{
		position fixed
		top 100px
		width 100%
		z-index 3000
		.mask{
			background-color #000
			opacity 0.8
			width 100%
			height 300px
			top -100px
			z-index -1
			position absolute
		}
		.arrow{
			width 0.46rem
			height 0.9rem
			background-image url(../assets/img/29.png)
			background-size contain
			position absolute
			right 0
			top -0.95rem
		}
		.contents{
			width 100%
			display flex
			justify-content center
			.text{
				color #000
				width 3.35rem
				min-height 0.54rem
				background-color #fff
				border-radius 0.12rem
				opacity 0.7
				display flex
				justify-content center
				align-items center
				font-size 0.16rem
			}
		}
	}
	.top{
		background-image url(../assets/img/1-2.png)
		background-size cover
		padding 0.4rem 0.2rem 0.2rem 0.2rem
		.user{
			display flex
			justify-content space-between
			.info{
				display flex
				align-items center
				.avatar img{
					width 0.54rem;
					height 0.54rem;
           border-radius 50%;
				}
				.nickname{
					font-size: 0.17rem;
					font-family: Eina01-Bold, Eina01;
					font-weight: bold;
					color: #FFFFFF;
					margin-left 0.12rem
					margin-right 0.12rem
				}
			}
			.date{
				color:white
				display flex
				align-items center
				.year-month-week{
					font-size: 0.12rem;
					font-family: DINPro-Regular, DINPro;
					font-weight: 400;
					line-height: 0.15rem
					text-align right
				}
				.day{
					border-left 0.01rem solid #fff
					padding-left 0.05rem
					margin-left 0.05rem
					padding-right 0.05rem
					margin-right 0.05rem
					font-size: 0.28rem;
					font-family: DINPro-Bold, DINPro;
					font-weight: bold;
				}
			}
		}
		.slogan{
			margin-top 0.2rem
			font-size: 0.23rem;
			font-family: Eina01-BoldItalic, Eina01;
			font-weight: 400;
			color: #FFFFFF;
			line-height: 1.3;
			text-align left
		}
     .invite-code {
       margin-top 0.2rem;
       font-weight 400;
       line-height 1.5;
       .label {
         font-size 0.18rem;
         color white;
       }
       .code {
         font-weight bold;
       }
       .desc {
         font-size 0.14rem;
         color rgba(white, 0.5);
       }
     }
	}
	.content{
		padding 0rem 0.2rem 0rem 0.2rem
		.description{
			background: #FFFFFF
			border-radius: 0.18rem
			padding 0.2rem 0.15rem
			.row{
				display flex
				align-items center
				margin-bottom 0.24rem
				&:last-child{
					margin-bottom 0rem
				}
				.ico{
					flex-shrink 0
					width 0.68rem
					height 0.68rem
					background-size contain
					background-position center
					background-repeat no-repeat
					&.ico-a{
						background-image url(../assets/img/4.png)
					}
					&.ico-b{
						background-image url(../assets/img/5.png)
					}
					&.ico-c{
						background-image url(../assets/img/6.png)
					}
				}
				.text{
					margin-left 0.12rem
					margin-right 0.12rem
					font-size: 0.15rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #2D363E;
					line-height: 0.26rem;
					.title{
						&.title-a{
							color:#FD6A00
						}
						&.title-b{
							color:#896FFF
						}
						&.title-c{
							color:#30B4FF
						}
					}
					.desc{

					}
				}
			}
		}
	}
	.bottom{
		width 100%
		position fixed
		bottom 0
		background-color #12284C
		background-image url(../assets/img/2.png)
		background-size contain
		background-repeat no-repeat
		.action{
			padding 0.1rem 0.2rem
			display flex
			justify-content space-between
			align-items center
			.logo-text{
				display flex
				align-items center
				.logo{
					flex-shrink 0
					width: 0.5rem;
					height: 0.5rem;
					background: #FFFFFF;
					border-radius: 0.12rem;
					background-image url(../assets/img/3.png)
					background-size 0.3885rem 0.3973rem
					background-position center
					background-repeat no-repeat
				}
				.text{
					margin-left 0.12rem
					margin-right 0.12rem
					font-size: 0.15rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #FFFFFF;
					line-height: 0.21rem;
				}
			}
			.button-open{
				flex-shrink 0
				width: 0.93rem;
				height: 0.42rem;
				background: linear-gradient(90deg, #FF6521 0%, #FFA545 100%);
				border-radius: 0.21rem;
				font-weight: 500;
				font-size: 0.15rem;
				font-family: PingFangSC-Medium, PingFang SC;
				color: #FFFFFF;
				display flex
				justify-content center
				align-items center
				text-align center
			}
		}
	}
}
.ug,.ar{
   text-orientation: sideways;
   direction: rtl;
   .user{
	   .date{
		   .day{
				border-left none!important;
				border-right 0.01rem solid #fff
		   }
		   .year-month-week{
			   text-align left!important
		   }
	   }
   }
}
</style>
